<div *nzModalTitle>
  <div class="modal-title">Звонок завершен</div>
</div>
<div class="modal">
  <div class="modal__body">
    <p>Абонент которому вы звоните отклонил вызов.</p>
  </div>

  <div class="modal__footer">
    <ui-button (click)="confirmModal()">Понятно</ui-button>
  </div>
</div>
